import { Translation, Language } from '../../contract/translation.contract';
import i18n from '@/shared/i18n/i18n';
export function extractTranslation<T>(translation: Translation<T> | undefined): T | undefined {
  return translation?.[i18n.locale as Language];
}

export function extractTranslationAndReturnFirst<T>(translation: Translation<T[]> | undefined): T | undefined {
  return extractTranslation(translation)?.[0];
}
